export const DEFAULT_FILE_NAME = "Improvement Plan";

export const DEFAULT_FILE_WIDTH = 800;

export const FILE_EXTENSIONS = {
    PDF: "pdf",
    XLSX: "xlsx",
}

export const FILE_TYPES = {
    PDF: "application/pdf",
    XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}